// ===========================
// FULL-LENGTH EXAM TYPES
// ===========================

// Admin - Exam Template CRUD
export const CREATE_EXAM_REQUEST = "CREATE_EXAM_REQUEST";
export const CREATE_EXAM_SUCCESS = "CREATE_EXAM_SUCCESS";
export const CREATE_EXAM_FAILURE = "CREATE_EXAM_FAILURE";

export const FETCH_EXAMS_REQUEST = "FETCH_EXAMS_REQUEST";
export const FETCH_EXAMS_SUCCESS = "FETCH_EXAMS_SUCCESS";
export const FETCH_EXAMS_FAILURE = "FETCH_EXAMS_FAILURE";

export const FETCH_EXAM_REQUEST = "FETCH_EXAM_REQUEST";
export const FETCH_EXAM_SUCCESS = "FETCH_EXAM_SUCCESS";
export const FETCH_EXAM_FAILURE = "FETCH_EXAM_FAILURE";

export const UPDATE_EXAM_REQUEST = "UPDATE_EXAM_REQUEST";
export const UPDATE_EXAM_SUCCESS = "UPDATE_EXAM_SUCCESS";
export const UPDATE_EXAM_FAILURE = "UPDATE_EXAM_FAILURE";

export const DELETE_EXAM_REQUEST = "DELETE_EXAM_REQUEST";
export const DELETE_EXAM_SUCCESS = "DELETE_EXAM_SUCCESS";
export const DELETE_EXAM_FAILURE = "DELETE_EXAM_FAILURE";

// Student - Exam Attempt CRUD
export const CREATE_EXAM_ATTEMPT_REQUEST = "CREATE_EXAM_ATTEMPT_REQUEST";
export const CREATE_EXAM_ATTEMPT_SUCCESS = "CREATE_EXAM_ATTEMPT_SUCCESS";
export const CREATE_EXAM_ATTEMPT_FAILURE = "CREATE_EXAM_ATTEMPT_FAILURE";

export const FETCH_EXAM_ATTEMPTS_REQUEST = "FETCH_EXAM_ATTEMPTS_REQUEST";
export const FETCH_EXAM_ATTEMPTS_SUCCESS = "FETCH_EXAM_ATTEMPTS_SUCCESS";
export const FETCH_EXAM_ATTEMPTS_FAILURE = "FETCH_EXAM_ATTEMPTS_FAILURE";

export const FETCH_EXAM_ATTEMPT_REQUEST = "FETCH_EXAM_ATTEMPT_REQUEST";
export const FETCH_EXAM_ATTEMPT_SUCCESS = "FETCH_EXAM_ATTEMPT_SUCCESS";
export const FETCH_EXAM_ATTEMPT_FAILURE = "FETCH_EXAM_ATTEMPT_FAILURE";

export const UPDATE_EXAM_ATTEMPT_REQUEST = "UPDATE_EXAM_ATTEMPT_REQUEST";
export const UPDATE_EXAM_ATTEMPT_SUCCESS = "UPDATE_EXAM_ATTEMPT_SUCCESS";
export const UPDATE_EXAM_ATTEMPT_FAILURE = "UPDATE_EXAM_ATTEMPT_FAILURE";

export const SAVE_EXAM_PROGRESS_REQUEST = "SAVE_EXAM_PROGRESS_REQUEST";
export const SAVE_EXAM_PROGRESS_SUCCESS = "SAVE_EXAM_PROGRESS_SUCCESS";
export const SAVE_EXAM_PROGRESS_FAILURE = "SAVE_EXAM_PROGRESS_FAILURE";

export const SUBMIT_EXAM_REQUEST = "SUBMIT_EXAM_REQUEST";
export const SUBMIT_EXAM_SUCCESS = "SUBMIT_EXAM_SUCCESS";
export const SUBMIT_EXAM_FAILURE = "SUBMIT_EXAM_FAILURE";

// Exam History (for analytics)
export const FETCH_EXAM_HISTORY_REQUEST = "FETCH_EXAM_HISTORY_REQUEST";
export const FETCH_EXAM_HISTORY_SUCCESS = "FETCH_EXAM_HISTORY_SUCCESS";
export const FETCH_EXAM_HISTORY_FAILURE = "FETCH_EXAM_HISTORY_FAILURE";

// Admin - All Exam Attempts (analytics)
export const FETCH_ALL_EXAM_ATTEMPTS_REQUEST = "FETCH_ALL_EXAM_ATTEMPTS_REQUEST";
export const FETCH_ALL_EXAM_ATTEMPTS_SUCCESS = "FETCH_ALL_EXAM_ATTEMPTS_SUCCESS";
export const FETCH_ALL_EXAM_ATTEMPTS_FAILURE = "FETCH_ALL_EXAM_ATTEMPTS_FAILURE";

// Admin - Per-Exam Question Analytics
export const FETCH_EXAM_QUESTION_ANALYTICS_REQUEST = "FETCH_EXAM_QUESTION_ANALYTICS_REQUEST";
export const FETCH_EXAM_QUESTION_ANALYTICS_SUCCESS = "FETCH_EXAM_QUESTION_ANALYTICS_SUCCESS";
export const FETCH_EXAM_QUESTION_ANALYTICS_FAILURE = "FETCH_EXAM_QUESTION_ANALYTICS_FAILURE";

// Admin - Enhanced Analytics (with user profiles + in-progress attempts)
export const FETCH_ENHANCED_ANALYTICS_REQUEST = "FETCH_ENHANCED_ANALYTICS_REQUEST";
export const FETCH_ENHANCED_ANALYTICS_SUCCESS = "FETCH_ENHANCED_ANALYTICS_SUCCESS";
export const FETCH_ENHANCED_ANALYTICS_FAILURE = "FETCH_ENHANCED_ANALYTICS_FAILURE";

// Admin - Student Exam Details (for modal)
export const FETCH_STUDENT_EXAM_DETAILS_REQUEST = "FETCH_STUDENT_EXAM_DETAILS_REQUEST";
export const FETCH_STUDENT_EXAM_DETAILS_SUCCESS = "FETCH_STUDENT_EXAM_DETAILS_SUCCESS";
export const FETCH_STUDENT_EXAM_DETAILS_FAILURE = "FETCH_STUDENT_EXAM_DETAILS_FAILURE";

// Admin - Exam Attempt Counts (SUCCESS dispatched by fetchFullLengthExamsCached)
export const FETCH_EXAM_ATTEMPT_COUNTS_SUCCESS = "FETCH_EXAM_ATTEMPT_COUNTS_SUCCESS";

// Admin - Archive Exam
export const ARCHIVE_EXAM_REQUEST = "ARCHIVE_EXAM_REQUEST";
export const ARCHIVE_EXAM_SUCCESS = "ARCHIVE_EXAM_SUCCESS";
export const ARCHIVE_EXAM_FAILURE = "ARCHIVE_EXAM_FAILURE";

// Clear/Reset
export const CLEAR_CURRENT_EXAM = "CLEAR_CURRENT_EXAM";
export const CLEAR_CURRENT_ATTEMPT = "CLEAR_CURRENT_ATTEMPT";
export const CLEAR_EXAM_HISTORY = "CLEAR_EXAM_HISTORY";
export const CLEAR_ENHANCED_ANALYTICS = "CLEAR_ENHANCED_ANALYTICS";
export const CLEAR_STUDENT_EXAM_DETAILS = "CLEAR_STUDENT_EXAM_DETAILS";
export const RESET_EXAM_STATE = "RESET_EXAM_STATE";
